// Predefined conditions for potentially blacklisted components
import type { Clause } from "./policy";


// Access for component only
// if NOT in Demo mode OR
// if in Demo mode AND with roles "admin" and "cpi_employee"
export const demo_access: Clause[] = [
    { demo: "exclude" },
    { demo: "only", rolesAllOf: ["admin", "cpi_employee"] },
]

// Access for component only
// if app is "assay-central" OR
// if app is NOT "assay-central" AND with roles "admin" and "cpi_employee"
export const ac_access: Clause[] = [
    { appIs: "assay-central" },
    { rolesAllOf: ["admin", "cpi_employee"], appNot: "assay-central" },
]

// Access for component only
// if user with roles "admin"
export const admin_access: Clause[] = [
    { rolesAllOf: ["admin"]}
]

// Access for component only
// if user has "admin" OR "org_admin" role
export const org_admin_access: Clause[] = [
    { rolesAnyOf: ["admin", "org_admin"]}
]

// Access for components only
// if not in readAcross mode AND with roles "admin" and "cpi_employee"
// if in readAcross mode
export const readacross_access: Clause[] = [
    { readAcross: "exclude", rolesAllOf: ["admin", "cpi_employee"] },
    { readAcross: "only" }
]


// Usage Example:
// import AccessGate from "../../../components/Auth/AccessGate";
// import { useAccess } from "../../../access/useAccess";
// import { demo_access, ac_access } from "../../../access/predefinedConditions";

// Function:
//     const { canAccess } = useAccess();
//     if (canAccess({or: demo_access})) ... do something

// Component Rendering:
//     <AccessGate
//         or={demo_access}
//     >
//         {some conditional component}
//     </AccessGate>